import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { isString } from './type';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(dayOfYear);
dayjs.extend(localizedFormat);

const defaultDateFormat = 'YYYY-MM-DD';
const minutesInHour = 60;
const hoursInDay = 24;
const dateLength = 10;

export const formatDatetime = ({
  format = defaultDateFormat,
  datetime,
} = {}) => dayjs(datetime || Date.now()).format(format);
export const convertToUTC = ({
  format = defaultDateFormat,
  datetime,
} = {}) => dayjs(datetime).utc().format(format);
export const createDate = ({ format, datetime } = {}) => dayjs(datetime || Date.now(), format);
export const getFromToTimeString = (fromDatetime, toDatetime) => {
  const formattedFromDate = formatDatetime({ format: 'MMMM D, YYYY', datetime: fromDatetime });
  const formattedFromTime = formatDatetime({ format: 'h:mma', datetime: fromDatetime });
  const formattedToTime = formatDatetime({ format: 'h:mma', datetime: toDatetime });

  return `${formattedFromDate} from ${formattedFromTime} to ${formattedToTime}`;
};
export const getDiff = ({ fromDatetime, toDatetime, unit }) => dayjs(fromDatetime)
  .diff(toDatetime, unit);
export const getMax = (...datetimes) => {
  const timestamps = datetimes.map((datetime) => createDate({ datetime }).valueOf());
  const indexOfMaxValue = timestamps.reduce((iMax, x, i, arr) => (x > arr[iMax] ? i : iMax), 0);

  return datetimes[indexOfMaxValue];
};
export const getDiffMessage = (minutes) => {
  const fullDays = Math.floor(minutes / minutesInHour / hoursInDay);
  const remainMinutesFoHours = minutes - fullDays * hoursInDay * minutesInHour;
  const fullHours = Math.floor(remainMinutesFoHours / minutesInHour);
  const remainMinutes = remainMinutesFoHours - fullHours * minutesInHour;

  return `${fullDays}d ${fullHours}h ${remainMinutes}m`;
};
export const getISODayOfWeek = (dayOfWeek = createDate().day()) => (!dayOfWeek ? 7 : dayOfWeek);
export const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export const getISODateStringFromDateAndTime = (date, time) => createDate({
  datetime: date.replace(/-/g, '/').substr(0, dateLength) + time,
  format: 'YYYY-MM-DDHH:mm',
}).toISOString();
export const getCurrentYear = () => new Date().getFullYear();

export const toLocalDate = (dateString) => (
  isString(dateString)
    ? new Date(dateString).toISOString().slice(0, -1)
    : dateString
);
